export class SapSource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentId",
            "baseName": "agentId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "shortName",
            "baseName": "shortName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sid",
            "baseName": "sid",
            "type": "string",
            "format": ""
        },
        {
            "name": "client",
            "baseName": "client",
            "type": "string",
            "format": ""
        },
        {
            "name": "glueDatabase",
            "baseName": "glueDatabase",
            "type": "string",
            "format": ""
        },
        {
            "name": "host",
            "baseName": "host",
            "type": "string",
            "format": ""
        },
        {
            "name": "systemNumber",
            "baseName": "systemNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "sapUser",
            "baseName": "sapUser",
            "type": "string",
            "format": ""
        },
        {
            "name": "release",
            "baseName": "release",
            "type": "string",
            "format": ""
        },
        {
            "name": "deploymentShape",
            "baseName": "deploymentShape",
            "type": "SapDeploymentShape",
            "format": ""
        },
        {
            "name": "privateLinkVariant",
            "baseName": "privateLinkVariant",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkState",
            "baseName": "privateLinkState",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkEndpointDns",
            "baseName": "privateLinkEndpointDns",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkAccepted",
            "baseName": "privateLinkAccepted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SapSourceStatus",
            "format": ""
        },
        {
            "name": "bulkProgressPct",
            "baseName": "bulkProgressPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "bulkBytesShipped",
            "baseName": "bulkBytesShipped",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bulkBytesTotal",
            "baseName": "bulkBytesTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cdcLagSeconds",
            "baseName": "cdcLagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "agentStatus",
            "baseName": "agentStatus",
            "type": "SapAgentStatus",
            "format": ""
        },
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentLastHeartbeat",
            "baseName": "agentLastHeartbeat",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "selectedObjects",
            "baseName": "selectedObjects",
            "type": "Array<SapObjectSelection>",
            "format": ""
        },
        {
            "name": "objectStats",
            "baseName": "objectStats",
            "type": "{ [key: string]: SapObjectStats; }",
            "format": ""
        },
        {
            "name": "scheduleStart",
            "baseName": "scheduleStart",
            "type": "SapScheduleStart",
            "format": ""
        },
        {
            "name": "cdcPollingSeconds",
            "baseName": "cdcPollingSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertCdcLagMinutes",
            "baseName": "alertCdcLagMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertErrorRatePct",
            "baseName": "alertErrorRatePct",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertAgentOfflineMinutes",
            "baseName": "alertAgentOfflineMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<SapEvent>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapSource.attributeTypeMap;
    }
    constructor() {
    }
}
